import * as React from 'react';
import FeatureUpdateNoticeContainer from 'containers/notice/FeatureUpdateNoticeContainer';

const FeatureUpdateNotice = () => {
  return <FeatureUpdateNoticeContainer />;
};

export default FeatureUpdateNotice;
